import React, { FunctionComponent } from 'react';
import TrustpilotMicroreviewCount from '../../../components/trustpilot/trustpilot-microreview-count/TrustpilotMicroReviewCount';
import PageSection from '../../../components/page-section/PageSection';
import { TextAlign } from '../../../types';
import ListReviews from '../../../containers/list-reviews/ListReviews';
import { ReviewTarget } from '../../../../domain/graphcms';

export interface ReviewsSectionProps {
  title: string,
  showReviewLink?: boolean,
}

const ReviewsSection: FunctionComponent<ReviewsSectionProps> = ({
  title,
  showReviewLink,
}) => (
  <PageSection backgroundColor="neutrals.lighter">
    <PageSection.Wrapper>
      <PageSection.Title textAlign={TextAlign.CENTER}>
        {title}
      </PageSection.Title>
    </PageSection.Wrapper>
    <PageSection.Wrapper withoutPad>
      <PageSection.Block>
        <ListReviews
          target={[ReviewTarget.COMPRATORE, ReviewTarget.VENDITORE]}
          showLink={showReviewLink}
        />
      </PageSection.Block>
      <PageSection.Block>
        <TrustpilotMicroreviewCount />
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default ReviewsSection;
